import { TAG_ENTITY_MAIN_KEY, TagEntityKeysOP } from './constants';
export var TagEntityScaledDataKeys;
(function (TagEntityScaledDataKeys) {
    TagEntityScaledDataKeys["SCALED_DATA"] = "tag-anomaly-scaled-data";
    TagEntityScaledDataKeys["SCALED_DATA_AVG"] = "tag-anomaly-scaled-data-avg";
    TagEntityScaledDataKeys["SCALED_DATA_AVG_LAST_THREE_DAYS"] = "tag-anomaly-scaled-data-avg-last-3-days";
    TagEntityScaledDataKeys["SCALED_DATA_AVG_IMPUTED"] = "tag-anomaly-scaled-data-avg-imputed";
    TagEntityScaledDataKeys["SCALED_DATA_AVG_LAST_THREE_DAYS_IMPUTED"] = "tag-anomaly-scaled-data-avg-last-3-days-imputed";
})(TagEntityScaledDataKeys || (TagEntityScaledDataKeys = {}));
export var TagEntityInputDataKeys;
(function (TagEntityInputDataKeys) {
    TagEntityInputDataKeys["INPUT_DATA"] = "tag-input-data";
})(TagEntityInputDataKeys || (TagEntityInputDataKeys = {}));
